import { AxiosPromise, AxiosResponse } from 'axios';

import { request } from '@cvt/clients/baseClient';
import { snakizeObject } from '@cvt/helpers/object';

import { mapSpecializationData } from './specializationClient.formatter';


const apiBaseUrl = import.meta.env.VITE__CVT_API_URL;

const getSpecializations = (params: Specializations.GetListParams): AxiosPromise<CVT.Query.PaginatedResults<Specializations.Specialization>> => {
  return request({
    options: {
      url: `${apiBaseUrl}/specializations/`,
      method: 'GET',
      params: snakizeObject(params),
    },
  }).then((data: AxiosResponse<CVT.Query.PaginatedResults<Specializations.SpecializationApi>>) => ({
    ...data,
    data: {
      ...data.data,
      results: data.data.results.map(mapSpecializationData),
    },
  }));
};

const getSpecialization = (params: { id: number }): AxiosPromise<Specializations.Specialization> => {
  return request({
    options: {
      url: `${apiBaseUrl}/specializations/${params.id}/`,
      method: 'GET',
    },
  }).then((data: AxiosResponse<Specializations.SpecializationApi>) => ({
    ...data,
    data: mapSpecializationData(data.data),
  }));
};


export const specializationClient = {
  getSpecializations,
  getSpecialization,
};
